import { observer } from "mobx-react";
import { WalletStore } from "../../stores/wallet/wallet-store";
import './add-credits-modal.scss';
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Input } from "../../../../components/inputs/input/input";
import WalletBalance from "./wallet-balance";
import FormFieldLineLayout from "../../../../components/layouts/form-field-line-layout/form-field-line-layout";
import { Note, NOTE_TYPE } from "../../../../components/note/note";
import { FontBody2 } from "../../../../components/fonts/font-body2/font-body2";
import { FormField } from "../../../../components/form-field/form-field";

interface IProps {
    walletStore: WalletStore;
    onCloseClick: () => void;
}

const AddCreditsModal: React.FC<IProps> = observer(({ walletStore, onCloseClick }) => {
    return (
        <DefaultModalLayout isCloseDisabled={false} onCloseClicked={() => walletStore.setShouldShowAddCreditsModal(false)}>
            <div className="add-credits-modal">
                <div className={'add-credits-modal-content'}>
                    <FontBody1 variant={FONT_VARIANT.BOLD}>{"Add Credits to Your Wallet"}</FontBody1>
                    <WalletBalance walletStore={walletStore} showAddCreditsButton={false} />
                    <div className="add-credits-modal-content-body-form">
                        <FormFieldLineLayout>
                            <FontBody2>
                                {`Make a one-time payment to add credits to your wallet balance.`}
                            </FontBody2>
                            <div className="add-credits-modal-form-field-container">
                                <div className="add-credits-modal-form-field-label">
                                    <FontBody1 variant={FONT_VARIANT.BOLD}>Amount to Add</FontBody1>
                                </div>
                                <div className="add-credits-modal-form-field-input">
                                    <FormField label={<FontBody2>{`Enter amount (minimum ${walletStore.minimumDepositAmountFormattedWithSymbol})`}</FontBody2>} required>
                                        <Input
                                            required
                                            validationCallback={walletStore.validateManualDepositAmountEditor}
                                            adornment={walletStore.walletCurrencySymbol}
                                            value={walletStore.manualDepositAmount}
                                            onChange={walletStore.setManualDepositAmount}
                                            type={'number'}
                                            temp={true}
                                            step={1}
                                            />
                                    </FormField>
                                    {!walletStore.validateManualDepositAmountEditor().isValid && walletStore.validateManualDepositAmountEditor().messages.map(message => (
                                        <FontBody2 key={message} color={FONT_COLOR.SEMANTIC_DANGER}>{message}</FontBody2>
                                    ))}
                                </div>
                            </div>

                            {walletStore.validateManualDepositAmountEditor().isValid && (
                                <Note type={NOTE_TYPE.INFORMATION}
                                    body={<>
                                        <div><FontBody1 variant={FONT_VARIANT.BOLD}>{"Upcoming Charge"}</FontBody1></div>
                                        <FontBody2>
                                            {`By clicking Confirm, you authorize ReturnGO to charge your payment method for ${walletStore.manualDepositAmountFormattedWithSymbol}.`}
                                        </FontBody2>
                                    </>} />
                            )}
                        </FormFieldLineLayout>
                    </div>
                </div>
                <div className="add-credits-modal-buttons">
                    <Button text={"Cancel"} onClick={onCloseClick} variant={BUTTON_VARIANTS.Tertiary} disabled={false} />
                    <Button 
                        text={"Confirm"} 
                        onClick={walletStore.manualDepositHandler}
                        variant={BUTTON_VARIANTS.Primary} 
                        isLoading={walletStore.isAddingCredits} 
                        hasLoader={true}
                        disabled={!walletStore.validateManualDepositAmountEditor().isValid}
                    />
                </div>
            </div>
        </DefaultModalLayout>
    );
});

export default AddCreditsModal;